export const TEST_ID_MAIN_CONTAINER = 'meta-source-button';
export const TEST_ID_OPEN_BUTTON = 'meta-source-open-button';
export const MAIN_BUTTON_TEST_ID = 'meta-source-main-button';
